type Handler = () => void;

const readyHandlers: Handler[] = [];

const handleState = () => {
  if (["interactive", "complete"].indexOf(document.readyState) > -1) {
    while (readyHandlers.length > 0) {
      readyHandlers.shift()();
    }
  }
};

class ReadyHandler {
  start() {
    document.onreadystatechange = handleState;
  }

  ready(handler: Handler) {
    readyHandlers.push(handler);
    handleState();
  }
}

export default new ReadyHandler();
